export enum BetStatus {
    Default = 0,
    Waiting = 1,
    Rejected = 2,
    Accepted = 3,
    NewOffer = 4
}